import React from 'react';

import styled from 'styled-components';

import ShopRequestsStyledTable from './ShopRequestsStyledTable';

const ShopRequestGroupsStyledTable = styled(ShopRequestsStyledTable)`
  &&&.ant-table-wrapper .ant-table-tbody .ant-table-row-level-0 > .ant-table-cell,
  &&&.ant-table-wrapper .ant-table-tbody .ant-table-row-level-0:hover > .ant-table-cell {
    background: var(--gray-medium) !important;
  }

  thead {
    th {
      z-index: 0;
    }
  }

  .ant-table-row-level-0 .ant-table-cell,
  .ant-table-row:first-child .ant-table-cell {
    border-top: solid 4px var(--line-gray);
  }

  .ant-table-row-level-0 {
    .ant-table-cell:last-of-type {
      border-right: solid 4px var(--line-gray);
    }
    .ant-table-cell:first-of-type {
      border-left: solid 4px var(--line-gray);
    }
  }

  .ant-table-column-sort {
    background: var(--gray-medium) !important;
  }
  .ant-table-expanded-row-level-1:last-of-type {
    .shop-request-group-table-row:last-of-type {
      border-bottom: solid 4px var(--line-gray);
    }
  }

  &&&.ant-table-wrapper .ant-table-tbody .ant-table-row.ant-table-row-selected > .ant-table-cell {
    background: #f0f6ff !important;
  }

  .shop-request-group-table-row {
    border-left: solid 4px var(--line-gray);
    border-right: solid 4px var(--line-gray);
  }

  .ant-table-expanded-row-level-1 {
    .ant-table-cell {
      padding: 0;
    }
  }

  .ant-table-row-expand-icon-cell {
    width: 32px !important;
    min-width: 32px !important;
    max-width: 32px !important;
    padding: 0 8px !important;
  }

  .ant-table-thead .ant-table-row-expand-icon-cell + .ant-table-cell {
    padding-left: 0 !important;
  }

  .ant-table-tbody .ant-table-row-expand-icon-cell + .ant-table-cell {
    padding-left: 8px !important;
  }
`;

export default ShopRequestGroupsStyledTable;
